module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fbchatnow-container"
  }, [_c('button', {
    staticClass: "f-button",
    class: _vm.fButtonClass,
    staticStyle: {
      "color": "rgb(255, 255, 255)",
      "background": "rgb(0, 0, 0)"
    },
    on: {
      "click": _vm.onCountDownSlideUp
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "f-title"
  }, [_vm._v("Need help?")])]), _vm._v(" "), _c('div', {
    staticClass: "f-box",
    style: (_vm.fBoxStyle)
  }, [_c('button', {
    staticClass: "f-close",
    staticStyle: {
      "border-color": "#000000"
    },
    on: {
      "click": _vm.onCountDownSlideDown
    }
  }, [_vm._v("x")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "fb-messengermessageus",
    staticStyle: {
      "font-size": "0.6em"
    },
    attrs: {
      "messenger_app_id": "782732588553167",
      "page_id": "418381418548219",
      "color": "white",
      "size": "standard"
    }
  }, [_vm._v("\n      message us at https://www.facebook.com/noctorus.studio.\n    ")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "f-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon-custom-fb.png"),
      "alt": "Facebook Chat"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border": "3px solid rgb(0, 0, 0)",
      "min-width": "290px",
      "min-height": "350px",
      "width": "auto",
      "height": "auto"
    },
    attrs: {
      "id": "fb-livechat-page"
    }
  }, [_c('div', {
    staticClass: "fb-page fb_iframe_widget",
    attrs: {
      "data-tabs": "messages",
      "data-height": "350",
      "data-width": "290",
      "data-href": "https://www.facebook.com/noctorus.studio",
      "data-small-header": "true",
      "data-adapt-container-width": "false",
      "data-hide-cover": "false",
      "data-show-facepile": "false",
      "data-show-posts": "false",
      "fb-xfbml-state": "rendered",
      "fb-iframe-plugin-query": "adapt_container_width=false&app_id=&container_width=290&height=350&hide_cover=false&href=https%3A%2F%2Fwww.facebook.com%2Fnoctorus.studio&locale=en_US&sdk=joey&show_facepile=false&show_posts=false&small_header=true&tabs=messages&width=290"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c55f3844","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FBChatNow.vue
// module id = 837
// module chunks = 1